import * as React from 'react';

import CssBaseline from '@mui/material/CssBaseline';

import AppTheme from '_components/shared-theme/AppTheme';
import { AccountLayout } from './';

import {
    chartsCustomizations,
    dataGridCustomizations,
    datePickersCustomizations,
    treeViewCustomizations,
} from '_components/theme/customizations';


const xThemeComponents = {
    ...chartsCustomizations,
    ...dataGridCustomizations,
    ...datePickersCustomizations,
    ...treeViewCustomizations,
};

export { AccLayout };

function AccLayout(props) {
    return (
        <AppTheme {...props} themeComponents={xThemeComponents}>
            <CssBaseline />
            {/* <Box sx={{ display: 'flex' }}> */}
            <AccountLayout />
            {/* </Box> */}
        </AppTheme>
    );
}
